




























































import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import { VersionString } from '@/constants/environment';

@Component({})
export default class ResetPasswordResult extends Vue
{
	errors : any[] = [];
	resetPasswordResult : string = "";

	mounted()
	{
	    this.resetPassword();
	}

	async resetPassword()
	{
	    const code = this.$route.query.code;
	    if (code != null)
	    {
	        try 
	        {
	            let res = await this.$http.post('resetpassword', null, { params: { code }});
	            if (res.data.error)
	            {
	                this.resetPasswordResult = `Password reset failed: ${res.data.error}`;
	                return;
	            }
	            this.resetPasswordResult = 'Successfully changed your password.';
	            return;
	        } 
	        catch (error) 
	        {
	            console.log(error);
	            let res = error.response;
	            if (res.data.error)
	            {
	                this.resetPasswordResult = `Password reset failed: ${res.data.error}`;
	                return;
	            }
	            else
	            {
	                this.resetPasswordResult = 'Internal error, please try again.';
	            }
	            return;
	        }
	    }
	    this.resetPasswordResult = 'Password reset code is missing.';
	    return;
	}

	navigateToLogin()
	{
	    this.$router.push('/login');
	}

	get VersionString() 
	{
	    return VersionString; 
	}
}
